<template>
    <div class="wrapper columns is-centered">
        <div class="column is-4-desktop is-6-tablet is-8-mobile is-offset-2-mobile">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'SiteLayout',
    inject: ['$validator'],
};
</script>

<style scoped>
    .wrapper {
        margin: 0;
        padding: 5rem 0 0 0;
        min-height: 100vh;
        background-color: #37474F;
    }
</style>
